module.exports = __webpack_public_path__ + "static/media/icon-7.cf7f6c65.png";